import { RestHelper } from '../helpers/RestHelper';
             
export class EmailService {

  private _restHelper;

  constructor() {
    this._restHelper = new RestHelper();
  }

  async SendNotifications(payload : any)  {
    const url : string  = "Email/SendNotifications";
    let response = await this._restHelper.post(url, payload);
    return response;
  }
}
